import Autocomplete from "@material-ui/lab/Autocomplete";
/* core components */
import React from "react";
import TextField from "@material-ui/core/TextField";
/* custom components */
import getDefaultValue from "utils/DefaultValue";

const ListboxOutPosition = props => {
  const [error] = React.useState(false);
  const [helperText] = React.useState("");

  let content = (
    <TextField disabled label="สาเหตุการพ้น" margin="normal" fullWidth />
  );

  const data = props.data;

  if (data && data.length > 0) {
    content = (
      <Autocomplete
        name="ListboxOutPosition"
        disabled={props.disabled}
        options={data}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={(e, v) => props.onChange(props.rowId, e, v)}
        renderInput={params => {
          return (
            <TextField
              {...params}
              error={error}
              helperText={helperText}
              label="เลือกสาเหตุการพ้น"
              margin="normal"
              fullWidth
            />
          );
        }}
        {...props.customProps}
      />
    );
  }

  return content;
};
export default ListboxOutPosition;
